import React from 'react';
import { FadeIn } from './FadeIn';
const testimonials = [{
  quote: 'התכשיט שעיצבו עבורי הוא לא רק פריט יופי, הוא פיסת היסטוריה אישית שאעביר לדורות הבאים.',
  author: 'ש. כהן'
}, {
  quote: 'רמת הגימור והדיוק היא משהו שקשה למצוא היום. זוהי אמנות לשמה.',
  author: 'י. לוי'
}];
export function Testimonials() {
  return <section className="py-32 md:py-48 bg-white/40" data-id="element-134">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12" data-id="element-135">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-20 md:gap-32" data-id="element-136">
          {testimonials.map((item, index) => <FadeIn key={index} delay={index * 0.2} className="flex flex-col items-center text-center" data-id="element-137">
              <p className="serif text-2xl md:text-3xl text-charcoal/80 leading-relaxed mb-10 italic" data-id="element-138">
                "{item.quote}"
              </p>
              <div className="w-8 h-px bg-gold mb-6" data-id="element-139" />
              <span className="label-tiny text-charcoal/60" data-id="element-140">{item.author}</span>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}